import React from "react";

const AboutUs = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
      <h1>About Us</h1>
      <p style={{ paddingLeft: "10px" }}>
        Welcome to Netcliff Tv, your destination for high-quality entertainment across movies,
        web series, and live channels.
      </p>

      <h2>Who We Are</h2>
      <p style={{ paddingLeft: "10px" }}>
        We are a digital streaming platform focused on delivering engaging content with a
        smooth and reliable viewing experience for audiences worldwide.
      </p>

      <h2>What We Offer</h2>
      <ul>
        <li>Curated catalog of web series</li>
        <li>Live TV streaming experiences</li>
        <li>Fast, secure, and user-friendly platform</li>
      </ul>

      <h2>Our Mission</h2>
      <p style={{ paddingLeft: "10px" }}>
        Our mission is to make great content easily accessible to everyone while continuously
        improving quality, performance, and user experience.
      </p>

      <h2>Contact</h2>
      <p style={{ paddingLeft: "10px" }}>
        For business or support queries, contact us at 
        <a href="mailto:contact@netcliff.tv"> contact@netcliff.tv</a>.
      </p>
    </div>
  );
};

export default AboutUs;
